import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const PublicScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useLayoutEffect(() => {
    // Preserve explicit section links, but start ordinary page navigation at the top.
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};

export default PublicScrollToTop;
